import { render, staticRenderFns } from "./tuitionCell.vue?vue&type=template&id=1463ce08"
import script from "./tuitionCell.vue?vue&type=script&lang=js"
export * from "./tuitionCell.vue?vue&type=script&lang=js"
import style0 from "./tuitionCell.vue?vue&type=style&index=0&id=1463ce08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports